<hs-lazy-load-panel [content]="lazyLoadPanelContent" [panelKey]="panelKey">
</hs-lazy-load-panel>
<ng-template #lazyLoadPanelContent>
  <div class="actions-grid-container" #rulesGrid>
    <hs-rules-grid
      (ruleIdSelected$)="setSelectedRuleId($event)"
      (resetPopOverFilter)="resetPopOverFilter()"
      [searchInput]="searchInput"
      ><hs-find-rules-popover
        (find)="onSearchSubmit($event)"
        [focusedIds]="focusedIds"
        #findRulePopover
      ></hs-find-rules-popover
    ></hs-rules-grid>
  </div>

  <hs-resize-handle
    [elem1]="rulesGrid"
    [elem2]="subPanels"
    [initialResizeHandleState]="state?.resizeHandleState"
    (resizeFinished)="onResizeFinished($event)"
  ></hs-resize-handle>

  <div id="details-sub-panels" #subPanels>
    <ul ngbNav #nav="ngbNav" class="nav-tabs">
      <li [ngbNavItem]="1">
        <a class="details-nav-item" ngbNavLink>Rule Code</a>
        <ng-template ngbNavContent>
          <hs-rule-code
            *ngIf="ruleIdSelected; else noSelectedRules"
            [ruleIdSelected]="ruleIdSelected"
          ></hs-rule-code
        ></ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a class="details-nav-item" ngbNavLink>Applied To</a>
        <ng-template ngbNavContent>
          <hs-rule-applied-to
            *ngIf="ruleIdSelected; else noSelectedRules"
            [ruleIdSelected]="ruleIdSelected"
          ></hs-rule-applied-to>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</ng-template>
<ng-template #noSelectedRules>
  <hs-panel-card header="No Rules Selected">
    <p>
      This panel requires a rule to be selected before information can be
      displayed. Select a rule to continue.
    </p>
  </hs-panel-card>
</ng-template>
